import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'sku-orders.dashboard.page-title',
    defaultMessage: 'Orders',
  },
  tabToday: {
    id: 'sku-orders.dashboard.tab-today',
    defaultMessage: 'Today',
  },
  tabHistory: {
    id: 'sku-orders.dashboard.tab-history',
    defaultMessage: 'History',
  },
  columnMemberName: {
    id: 'sku-orders.dashboard.column-member-name',
    defaultMessage: 'Member name',
  },
  columnOrderId: {
    id: 'sku-orders.dashboard.column-order-id',
    defaultMessage: 'Order ID',
  },
  columnItem: {
    id: 'sku-orders.dashboard.column-item',
    defaultMessage: 'Item',
  },
  columnPayout: {
    id: 'sku-orders.dashboard.column-payout',
    defaultMessage: 'Payout',
  },
  payoutTooltip: {
    id: 'sku-orders.dashboard.payout-tooltip',
    defaultMessage: 'Estimated payout',
  },
  columnOrderPlaced: {
    id: 'sku-orders.dashboard.column-order-placed',
    defaultMessage: 'Order placed',
  },
  columnPickupTime: {
    id: 'sku-orders.dashboard.column-pickup-time',
    defaultMessage: 'Pickup time',
  },
  columnStatus: {
    id: 'sku-orders.dashboard.column-status',
    defaultMessage: 'Status',
  },
  markFulfilled: {
    id: 'sku-orders.dashboard.mark-fulfilled',
    defaultMessage: 'Mark as fulfilled',
  },
  emptyOrders: {
    id: 'sku-orders.dashboard.empty-orders',
    defaultMessage: 'No orders found.',
  },
  emptyOrdersSubtitle: {
    id: 'sku-orders.dashboard.empty-orders-subtitle',
    defaultMessage: 'Your new orders will appear here as ClassPass{br}members book them.',
  },
  emptyIcon: {
    id: 'sku-orders.dashboard.empty-icon',
    defaultMessage: 'No orders icon',
  },
  settingsButton: {
    id: 'sku-orders.dashboard.settings-button',
    defaultMessage: 'Settings',
  },
  manageItems: {
    id: 'sku-orders.dashboard.manage-items',
    defaultMessage: 'Manage items',
  },
  fulfillOrderError: {
    id: 'sku-orders.dashboard.fulfill-order-error',
    defaultMessage: 'Failed to mark order as fulfilled. Please try again.',
  },
  loadOrdersError: {
    id: 'sku-orders.dashboard.load-orders-error',
    defaultMessage: 'Failed to load orders. Please try again.',
  },
  orderActionsMenu: {
    id: 'sku-orders.dashboard.order-actions-menu',
    defaultMessage: 'Order actions',
  },
  orderActionEditItem: {
    id: 'sku-orders.dashboard.order-action-edit-item',
    defaultMessage: 'Edit item',
  },
  orderActionCustomerMissedPickup: {
    id: 'sku-orders.dashboard.order-action-customer-missed-pickup',
    defaultMessage: 'Customer missed pickup',
  },
  cancelOrderError: {
    id: 'sku-orders.dashboard.cancel-order-error',
    defaultMessage: 'Failed to cancel order. Please try again.',
  },
  itemOutOfStockError: {
    id: 'sku-orders.dashboard.item-out-of-stock-error',
    defaultMessage: 'Failed to mark item as out of stock. Please try again.',
  },
  cancelOrderModalTitle: {
    id: 'sku-orders.dashboard.cancel-order-modal-title',
    defaultMessage: 'Confirm and notify customer',
  },
  cancelOrderSubjectOutOfStock: {
    id: 'sku-orders.dashboard.cancel-order-subject-out-of-stock',
    defaultMessage: 'Your order at {venueName} has been cancelled due to an out of stock item.',
  },
  cancelOrderSubjectPartnerCancelled: {
    id: 'sku-orders.dashboard.cancel-order-subject-partner-cancelled',
    defaultMessage: 'Your order at {venueName} has been cancelled by the business.',
  },
  cancelOrderMessageOutOfStock: {
    id: 'sku-orders.dashboard.cancel-order-message-out-of-stock',
    defaultMessage:
      "Your {dateTimeHtml} order at {venueHtml} has been cancelled because an item is out of stock.<br /><br />Out of stock item:<br />{itemHtml}<br /><br />{refundBold}<br /><br />If you''d like, you may select another item from {venueMenuHtml}.",
  },
  cancelOrderMessagePartnerCancelled: {
    id: 'sku-orders.dashboard.cancel-order-message-partner-cancelled',
    defaultMessage:
      'Your {dateTimeHtml} order at {venueHtml} has been cancelled by the business. Your credits will be refunded for this item.<br /><br />Item in order:<br />{itemHtml}<br /><br />{contactBusinessHtml} with any questions.',
  },
  cancelOrderNotifyButton: {
    id: 'sku-orders.dashboard.cancel-order-notify-button',
    defaultMessage: 'Notify customer',
  },
  cancelOrderSuccess: {
    id: 'sku-orders.dashboard.cancel-order-success',
    defaultMessage: 'Order cancelled',
  },
});
